export class Log {
  static default = new this({
    space: "global",
    handler: consoleLogHandler
  });
  _handler;
  _space;
  _type = "log";
  constructor(options) {
    this._handler = options?.handler || Log.default._handler;
    this._space = options?.space || Log.default._space;
  }
  debug(message, data) {
    this.write("debug", message, data);
  }
  info(message, data) {
    this.write("info", message, data);
  }
  warn(message, data) {
    this.write("warn", message, data);
  }
  error(message, data) {
    const error = message instanceof Error ? message : null;
    if (error) {
      data = {
        error: message,
        ...data
      };
    }
    this.write("error", error?.message ?? message, data);
  }
  write(level, message, data) {
    if (typeof data !== "undefined") {
      data = typeof data !== "object" ? { data } : data;
    }
    if (this._handler) {
      this._handler({ level, message, data, space: this._space });
    } else {
      const logFunc = console[level] || console.log;
      logFunc.apply(console, data ? [message, data] : [message]);
    }
  }
  /**
   * Create a new sub-space.
   * All spaces are being separated by a dot. E.g. `global.api` and `global.api.getUser`
   * @param subSpace The name of the sub-space in camel-case (e.g. `api` and `api.getUser`)
   */
  space(subSpace) {
    return new Log({
      space: `${this._space}.${subSpace}`,
      handler: this._handler
    });
  }
  /**
   * Measure the time of a function.
   */
  async time(message, func) {
    const start = Date.now();
    const result = await func();
    const end = Date.now();
    this.debug(`${message} took ${end - start}ms`);
    return result;
  }
  /**
   * Attach the log to the request object: `req.$log`.
   * This function should be called in a server middleware before storefront-core is initialized.
   */
  static attachToRequest(req, log) {
    req.$log = log;
  }
}
function consoleLogHandler({ level, message, data }) {
  const logFunc = console[level] || console.log;
  logFunc.apply(console, data ? [message, data] : [message]);
}
